import type { StoryObj } from '@storybook/html'
import type { CobaltTooltip as CobaltTooltipProps } from './cobalt-tooltip'
import { COLORS } from '@pollux-docaposte/core-design-system/dist/core-design-system/tokens/colors'

const colorsAvailable = Object.keys(COLORS)

export default {
  title: 'Components/Feedback/cobalt-tooltip',
  argTypes: {
    direction: {
      control: 'select',
      options: ['top', 'right', 'bottom', 'left'],
      description: 'Tooltip alignment prop to where the tooltip will appear.',
      type: { name: 'string' },
      table: {
        type: { summary: 'string' },
        defaultValue: { summary: 'top' }
      }
    },
    tooltipBackgroundColor: {
      control: 'select',
      options: colorsAvailable,
      description: 'Change the `background-color` of the tooltip content.`',
      table: {
        type: { summary: 'string' },
        defaultValue: { summary: 'color-neutral-background-strong' }
      }
    },
    tooltipColor: {
      control: 'select',
      options: colorsAvailable,
      description: 'Change the `color` of the tooltip content.',
      table: {
        type: { summary: 'string' },
        defaultValue: { summary: 'color-neutral-content-medium' }
      }
    },
    tooltipPadding: {
      control: 'text',
      description: 'Change the `padding` of the tooltip content.',
      table: {
        type: { summary: 'string' },
        defaultValue: { summary: 'var(--number-spacing-4xsmall) var(--number-spacing-3xsmall)' }
      }
    }
  }
}

const TemplateDefault = (args: CobaltTooltipProps) => {
  return `
<div style="display: flex; align-items: center; justify-content: center; padding: 5rem;">
  <cobalt-tooltip direction="${args.direction}" tooltip-background-color="${args.tooltipBackgroundColor}" tooltip-color="${args.tooltipColor}" tooltip-padding="${args.tooltipPadding}">
    <span slot="tooltip-content">Tooltip message</span>
  </cobalt-tooltip>
</div>
  `
}

const TemplateCustom = (args: CobaltTooltipProps) => {
  return `
<div style="display: flex; align-items: center; justify-content: center; padding: 5rem;">
  <cobalt-tooltip direction="${args.direction}">
    <p slot="trigger-element" class="typography-body-small-regular">Hover Me</p>
    <span slot="tooltip-content">Tooltip message</span>
  </cobalt-tooltip>
</div>
  `
}

export const Default: StoryObj = TemplateDefault.bind({})

Default.args = {
  direction: 'top',
  tooltipBackgroundColor: 'color-neutral-background-strong',
  tooltipColor: 'color-neutral-content-medium',
  tooltipPadding: 'var(--number-spacing-3xsmall) var(--number-spacing-2xsmall)'
}

export const WithCustomTriggerElement: StoryObj = TemplateCustom.bind({})

WithCustomTriggerElement.args = {
  direction: 'top'
}
